import { Badge } from '@shared/ui';

import { clientStatusBadge } from './client-status';

import type { ClientSummary } from '../schemas/client';

/** The client's status badge, shared by the list, the title line and the rail. */
export function ClientStatusBadge({
    client,
}: {
    client: Pick<ClientSummary, 'isSandbox' | 'status'>;
}) {
    const { label, tone } = clientStatusBadge(client);
    return (
        <Badge tone={tone} dot>
            {label}
        </Badge>
    );
}
